// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"121":"gallery","177":"home","246":"landing","255":"private_events","316":"menus","342":"press","443":"about","566":"catering","631":"contact","913":"default"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".chunk.js";
};